import type { ShellNode } from '@vedalib/editor'
import { isShellNode } from '@vedalib/editor'
import React from 'react'

import { getShellStyle } from 'components/Editor/EditorContext/selectors/styles'
import { AppMode, PreviewMode } from 'services/Store/Project/enums'
import { useProjectContext } from 'services/Store/Project/hooks'
import { getEditorMode } from 'services/Store/Project/selectors'

import type { INodeComponentProps, IShellProps } from '../Node/types'
import EditorElementRenderer from './EditorShell'
import PreviewElementRenderer from './PreviewShell'

const BLOCK_COMPONENTS: Partial<Record<PreviewMode, React.FC<IShellProps>>> = {
  editor: EditorElementRenderer,
}

const ShellContainer: React.FC<INodeComponentProps<ShellNode>> = (props) => {
  const { node, mode } = props
  const editorMode = useProjectContext(getEditorMode)

  if (!isShellNode(node)) {
    return null
  }

  const previewMode =
    mode.previewMode === PreviewMode.editor && editorMode === AppMode.fill && node.hideOnFill
      ? PreviewMode.preview
      : mode.previewMode

  const Component = BLOCK_COMPONENTS[previewMode] || PreviewElementRenderer
  const { style, wrapperStyle } = getShellStyle(node as ShellNode, mode.deviceMode)
  return <Component {...props} node={node} style={style} wrapperStyle={wrapperStyle} />
}

export default React.memo(ShellContainer)
